<template>
  <RouterView />
  <div class="pointer-events-none fixed inset-x-0 bottom-6 z-[80] flex flex-col items-center gap-2">
    <div
      v-for="item in toast.items"
      :key="item.id"
      class="pointer-events-auto rounded-md border px-4 py-2.5 text-sm shadow-lg"
      :class="{
        'border-emerald-500/30 bg-[#0b1624] text-emerald-200': item.variant === 'success',
        'border-sky-500/30 bg-[#0b1624] text-sky-200': item.variant === 'info',
        'border-amber-500/30 bg-[#0b1624] text-amber-200': item.variant === 'warning',
        'border-rose-500/30 bg-[#0b1624] text-rose-200': item.variant === 'error',
      }"
    >
      {{ item.message }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { toast } from '@/lib/toast'
</script>
